import callAPI from "../callApi";
import path from "../variables";

const Manifest = {
	generate: (filter?: string) =>
		callAPI("GET", `${path.base}/planning/manifest${filter || ""}`, "", "generating manifest"),
};

export default Manifest;
